import Typography from '@mui/material/Typography';
import { StandardButton, type StandardButtonProps } from './StandardButton';

const defaultText = 'Show Details';

export const ShowDetailsButton = ({
  text,
  children,
  ...props
}: Omit<StandardButtonProps, 'startIcon' | 'endIcon'>) => (
  <StandardButton variant="contained" color="primary" {...props}>
    <Typography variant="inherit" noWrap>
      {children || defaultText}
    </Typography>
  </StandardButton>
);
